import { render, staticRenderFns } from "./Lgx209045111810555904.vue?vue&type=template&id=3913be20&scoped=true&"
import script from "./Lgx209045111810555904.vue?vue&type=script&lang=js&"
export * from "./Lgx209045111810555904.vue?vue&type=script&lang=js&"
import style0 from "./Lgx209045111810555904.vue?vue&type=style&index=0&id=3913be20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3913be20",
  null
  
)

export default component.exports